// Lumina (23.10.2026): projekcja fal za lampką na górze karty, ten sam wzór co tło aplikacji Lumina Sounds (07-aplikacja/tla.js, motyw „woda”).
// Od poprawki 23.10 fale nie są tłem całej strony (rozpraszały przy czytaniu): płótno siedzi za galerią (.cz-gallery),
// wygasa miękko maską (assets/lumina-noc.css, .ln-fale) i rusza się wolniej. Strony bez galerii zostają na gładkim granacie.
// Przy „ogranicz ruch” jedna klatka; na ukrytej karcie albo gdy galerii nie widać, animacja stoi.
(function () {
  if (window.__lnFale) return;
  var galeria = document.querySelector('.cz-gallery');
  if (!galeria) return;
  window.__lnFale = true;
  var malyRuch = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Film otwierania lampki na pierwszym slajdzie (sections/drop-produkt-v2.liquid, data-ln-film):
  // raz od początku do zapalonej lampki i stop na ostatniej klatce; dotknięcie albo powrót do slajdu odtwarza od nowa.
  var film = galeria.querySelector('[data-ln-film]');
  if (film) {
    film.loop = false;
    var odNowa = function () { if (malyRuch.matches) return; film.currentTime = 0; var p = film.play(); if (p && p.catch) p.catch(function () {}); };
    if (malyRuch.matches) {
      film.removeAttribute('autoplay'); film.pause();
      var naKoniec = function () { film.currentTime = Math.max(0, film.duration - 0.05); };
      film.readyState >= 1 ? naKoniec() : film.addEventListener('loadedmetadata', naKoniec, { once: true });
    }
    film.parentElement.addEventListener('click', odNowa);
    var tasma = film.closest('[data-cz-slides]');
    if ('IntersectionObserver' in window && tasma) {
      var byl = true;
      new IntersectionObserver(function (w) {
        var teraz = w[0].intersectionRatio > 0.6;
        if (teraz && !byl && film.ended) odNowa();
        byl = teraz;
      }, { root: tasma, threshold: [0, 0.6] }).observe(film.parentElement);
    }
  }

  var TLO = [6, 26, 48], SWIATLO = [30, 150, 195], GORA = [15, 45, 10];
  var TEMPO = 0.00022;
  if (getComputedStyle(galeria).position === 'static') galeria.style.position = 'relative';
  var cv = document.createElement('canvas');
  cv.className = 'ln-fale';
  cv.setAttribute('aria-hidden', 'true');
  galeria.insertBefore(cv, galeria.firstChild);
  var cx = cv.getContext('2d');
  var W = 128, H = 120, img, anim = 0, ostatnia = 0, t0 = performance.now(), widac = true;
  cv.width = W; cv.height = H;
  img = cx.createImageData(W, H);

  function rysuj(czas) {
    var t = czas * TEMPO + 23, d = img.data;
    for (var y = 0; y < H; y++) {
      var g = 1 - y / H;
      for (var x = 0; x < W; x++) {
        var px = (x / W) * 6.28 * (W / 96) - 250, py = (y / H) * 8.2 * (H / 128) - 250;
        var ix = px, iy = py, c = 1;
        for (var n = 0; n < 4; n++) {
          var tt = t * (1 - 3.5 / (n + 1));
          var nx = px + Math.cos(tt - ix) + Math.sin(tt + iy);
          var ny = py + Math.sin(tt - iy) + Math.cos(tt + ix);
          ix = nx; iy = ny;
          c += 1 / Math.hypot(px / (Math.sin(ix + tt) / 0.005), py / (Math.cos(iy + tt) / 0.005));
        }
        c /= 4;
        c = 1.17 - Math.pow(c, 1.4);
        var v = Math.min(1, Math.pow(Math.abs(c), 7));
        var i = (y * W + x) * 4;
        d[i] = TLO[0] + v * (SWIATLO[0] + g * GORA[0]);
        d[i + 1] = TLO[1] + v * (SWIATLO[1] + g * GORA[1]);
        d[i + 2] = TLO[2] + v * (SWIATLO[2] + g * GORA[2]);
        d[i + 3] = 255;
      }
    }
    cx.putImageData(img, 0, 0);
  }

  function petla(teraz) {
    if (teraz - ostatnia > 50) { rysuj(teraz - t0 + 9000); ostatnia = teraz; }
    anim = requestAnimationFrame(petla);
  }
  function start() { if (!anim && widac && !malyRuch.matches && !document.hidden) anim = requestAnimationFrame(petla); }
  function stop() { cancelAnimationFrame(anim); anim = 0; }

  rysuj(9000);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (w) { widac = w[0].isIntersecting; widac ? start() : stop(); }).observe(galeria);
  }
  document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  if (malyRuch.addEventListener) malyRuch.addEventListener('change', function () { malyRuch.matches ? stop() : start(); });
  start();
})();
